import { createContext } from 'react';

export const MenuActive = createContext("");